import React from 'react';
export const isotipo = (props) => {
  return (
    <svg
      width='39'
      height='39'
      viewBox='0 0 39 39'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g id='Logo'>
        <rect
          id='Rectangle 616'
          width='39'
          height='39'
          rx='9.36'
          fill='black'
        />
        <g id='Ellipse 158'>
          <mask id='path-2-inside-1_25_25721' fill='white'>
            <path d='M24.765 10.3807C25.9625 11.0721 27.0122 11.9926 27.854 13.0897C28.6958 14.1868 29.3133 15.4389 29.6712 16.7746C30.0291 18.1103 30.1204 19.5034 29.9399 20.8744C29.7594 22.2454 29.3106 23.5674 28.6192 24.765C27.9278 25.9625 27.0073 27.0122 25.9102 27.854C24.8132 28.6958 23.561 29.3133 22.2253 29.6712C20.8896 30.0291 19.4965 30.1204 18.1255 29.9399C16.7545 29.7594 15.4325 29.3106 14.235 28.6192L15.7799 25.9433C16.6261 26.4318 17.5601 26.7489 18.5288 26.8765C19.4975 27.004 20.4819 26.9395 21.4256 26.6866C22.3694 26.4337 23.2541 25.9974 24.0292 25.4026C24.8044 24.8078 25.4548 24.0662 25.9433 23.22C26.4318 22.3739 26.7489 21.4398 26.8765 20.4711C27.004 19.5024 26.9395 18.5181 26.6866 17.5743C26.4337 16.6306 25.9974 15.7458 25.4026 14.9707C24.8078 14.1956 24.0662 13.5451 23.22 13.0566L24.765 10.3807Z' />
          </mask>
          <path
            d='M24.765 10.3807C25.9625 11.0721 27.0122 11.9926 27.854 13.0897C28.6958 14.1868 29.3133 15.4389 29.6712 16.7746C30.0291 18.1103 30.1204 19.5034 29.9399 20.8744C29.7594 22.2454 29.3106 23.5674 28.6192 24.765C27.9278 25.9625 27.0073 27.0122 25.9102 27.854C24.8132 28.6958 23.561 29.3133 22.2253 29.6712C20.8896 30.0291 19.4965 30.1204 18.1255 29.9399C16.7545 29.7594 15.4325 29.3106 14.235 28.6192L15.7799 25.9433C16.6261 26.4318 17.5601 26.7489 18.5288 26.8765C19.4975 27.004 20.4819 26.9395 21.4256 26.6866C22.3694 26.4337 23.2541 25.9974 24.0292 25.4026C24.8044 24.8078 25.4548 24.0662 25.9433 23.22C26.4318 22.3739 26.7489 21.4398 26.8765 20.4711C27.004 19.5024 26.9395 18.5181 26.6866 17.5743C26.4337 16.6306 25.9974 15.7458 25.4026 14.9707C24.8078 14.1956 24.0662 13.5451 23.22 13.0566L24.765 10.3807Z'
            stroke='#00AB92'
            stroke-width='3.12'
            mask='url(#path-2-inside-1_25_25721)'
          />
        </g>
        <path
          id='Ellipse 159'
          d='M14.235 28.6193C13.0375 27.9279 11.9878 27.0074 11.146 25.9103C10.3042 24.8132 9.68673 23.5611 9.32883 22.2254C8.97093 20.8897 8.87962 19.4966 9.06011 18.1256C9.24061 16.7546 9.68937 15.4326 10.3808 14.235C11.0722 13.0375 11.9927 11.9878 13.0898 11.146C14.1868 10.3042 15.439 9.68673 16.7747 9.32883C18.1104 8.97093 19.5035 8.87962 20.8745 9.06012C22.2455 9.24061 23.5675 9.68937 24.765 10.3808L23.2175 13.0612C22.3719 12.573 21.4385 12.2561 20.4705 12.1287C19.5025 12.0012 18.5188 12.0657 17.5757 12.3184C16.6326 12.5711 15.7485 13.0071 14.9739 13.6015C14.1993 14.1959 13.5494 14.937 13.0612 15.7826C12.573 16.6281 12.2561 17.5616 12.1287 18.5296C12.0012 19.4976 12.0657 20.4812 12.3184 21.4243C12.5711 22.3674 13.0071 23.2515 13.6015 24.0261C14.1959 24.8008 14.937 25.4507 15.7826 25.9389L14.235 28.6193Z'
          fill='white'
        />
        <rect
          id='Rectangle 1974'
          x='23.9807'
          y='9.64648'
          width='1.95'
          height='21.765'
          transform='rotate(30 23.9807 9.64648)'
          fill='black'
        />
      </g>
    </svg>
  );
};
export const logo = (props) => {
  return (
    <svg
      width='337'
      height='102'
      viewBox='0 0 337 102'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clip-path='url(#clip0_221_13310)'>
        <path
          d='M284.2 35.0001H284.184C284.184 35.0001 284.184 34.9785 284.184 34.9731C284.184 29.3868 281.488 24.8628 275.529 24.8628C269.571 24.8628 266.875 29.3868 266.875 34.9731C266.875 34.9839 266.875 34.9947 266.875 35.0001V93.0684C266.875 97.4091 271.226 100.925 275.529 100.925C280.059 100.925 284.179 97.4091 284.184 93.0684H284.2V35.0001Z'
          fill='#231F20'
        />
        <path
          d='M312.347 10.1103H312.331C312.331 4.52942 309.635 0 303.676 0C297.718 0 295.022 4.52942 295.022 10.1103V93.0635C295.022 97.4096 299.373 100.925 303.676 100.925C308.206 100.925 312.325 97.4096 312.331 93.0689H312.347V10.1103Z'
          fill='#231F20'
        />
        <path
          d='M109.019 60.9313C109.019 49.3921 108.21 40.5004 103.621 34.968C99.5019 30.0072 94.3416 25.4832 83.1959 24.8901C71.4787 24.27 64.7547 29.6082 58.6993 38.5161C54.5096 30.018 47.7855 25.5263 38.9532 24.9871C30.1208 24.4479 26.7992 26.8043 21.0835 30.4871V45.7685C21.0835 45.7685 25.8933 39.9989 34.8551 41.4548C42.3125 43.6225 45.8497 49.6293 45.8497 58.5534V93.0687H45.8551C45.8551 97.4094 50.2066 100.93 54.5096 100.93C59.039 100.93 63.1586 97.4094 63.164 93.0687H63.1694V57.9495C63.2395 55.8357 63.741 50.271 67.0032 45.9249C71.1121 40.4465 78.6234 41.4063 78.6234 41.4063C78.6234 41.4063 85.2557 41.32 88.8254 46.8901C92.395 52.4602 91.6994 60.9367 91.6994 60.9367V93.0741H91.7048C91.7048 97.4148 96.0563 100.936 100.359 100.936C104.889 100.936 109.008 97.4148 109.014 93.0741H109.019V60.9367V60.9313Z'
          fill='#231F20'
        />
        <path
          d='M17.3035 34.9682C17.3035 29.3873 14.6074 24.8579 8.64905 24.8579C2.69069 24.8579 0 29.3873 0 34.9682C0 34.979 0 34.9898 0 34.9952V93.0581C0 97.4042 4.35148 100.92 8.65444 100.92C13.1839 100.92 17.3035 97.3988 17.3089 93.0581H17.3251V34.9898H17.3089C17.3089 34.9898 17.3089 34.9682 17.3089 34.9628'
          fill='#231F20'
        />
        <path
          d='M284.416 11.1136C284.416 16.015 280.442 19.9945 275.535 19.9945C270.628 19.9945 266.654 16.0204 266.654 11.1136C266.654 6.20668 270.628 2.23804 275.535 2.23804C280.442 2.23804 284.416 6.21207 284.416 11.1136Z'
          fill='#231F20'
        />
        <path
          d='M337 92.0503C337 96.9518 333.026 100.931 328.119 100.931C323.212 100.931 319.238 96.9572 319.238 92.0503C319.238 87.1434 323.212 83.1748 328.119 83.1748C333.026 83.1748 337 87.1488 337 92.0503Z'
          fill='#231F20'
        />
        <path
          d='M146.155 82.1228C139.328 78.5046 134.67 71.3276 134.67 63.0614C134.67 51.1555 144.322 41.5035 156.227 41.5035C158.756 41.5035 161.188 41.9457 163.442 42.7437L170.247 27.252C165.901 25.5481 161.177 24.6152 156.227 24.6152C134.993 24.6152 117.781 41.827 117.781 63.0614C117.781 78.2404 126.576 91.3596 139.35 97.6145L146.155 82.1228Z'
          fill='#231F20'
        />
        <path
          d='M173.342 28.627L166.537 44.1241C173.239 47.78 177.79 54.8922 177.79 63.0614C177.79 74.9673 168.138 84.6193 156.233 84.6193C153.795 84.6193 151.45 84.2095 149.266 83.46L142.461 98.9625C146.737 100.602 151.38 101.508 156.238 101.508C177.472 101.508 194.684 84.2957 194.684 63.0614C194.684 47.9741 185.997 34.9196 173.347 28.627'
          fill='#02614B'
        />
        <path
          d='M213.87 30.2561C211.271 23.2463 203.377 25.4679 203.377 25.4679C203.377 25.4679 199.462 26.4169 198.087 30.8924C197.472 32.8983 197.596 35.0606 198.33 37.0287L219.79 94.3583L227.792 70.994C227.792 70.994 215.638 35.2169 213.87 30.2561Z'
          fill='#231F20'
        />
        <path
          d='M257.26 25.7587C249.852 23.3322 246.514 28.471 246.153 29.5009L222.6 98.0839C222.6 98.0839 225.242 101.114 230.251 101.087C235.26 101.06 238.329 98.154 239.202 96.2721C240.022 94.5089 259.385 42.3882 261.795 35.896C262.07 35.1573 262.232 34.3808 262.232 33.5881C262.232 30.8705 260.954 26.9612 257.26 25.7533'
          fill='#231F20'
        />
      </g>
      <defs>
        <clipPath id='clip0_221_13310'>
          <rect width='337' height='102' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
